module.exports = __webpack_public_path__ + "static/0014-c64d62cd8835863968d3a6527f232bb1.png";